import { TransactionOverview } from '../types/transactionType.ts';

interface FormOverviewSlice {
    crosscheckOverview: number;
    withdrawalOverview: number;
    depositOverview: number;
    ambulanceOverview: number;
    shiftChangeInventoryOverview: number;
    inventoryRecordOverview: number;
    inventoryOverview: number;
    isDoubleSignature: boolean;
    acceptSaldoMismatchCheckbox: boolean;
    connectedTransactionRecordId: string | null;
    connectedTransactionRecordIds: string[] | null;
    setCrosscheckOverview: (value: number) => void;
    setWithdralOverview: (value: number) => void;
    setDepositOverview: (value: number) => void;
    setDisposedOverview: (value: number) => void;
    setAmbulanceOverview: (value: number) => void;
    setShiftChangeInventoryOverview: (value: number) => void;
    setInventoryOverview: (value: number) => void;
    setInventoryRecordOverview: (value: number) => void;
    setDoubleSignature: (value: boolean) => void;
    setAcceptSaldoMismatchCheckbox: (value: boolean) => void;
    setConnectedTransactionRecordId: (value: string) => void;
    setConnectedTransactionRecordIds: (value: string[]) => void;
    resetOverviews: () => void;
}

const createFormOverviewSlice = (set: any) => ({
    crosscheckOverview: TransactionOverview.formOverview,
    withdrawalOverview: TransactionOverview.formOverview,
    depositOverview: TransactionOverview.formOverview,
    ambulanceOverview: TransactionOverview.formOverview,
    shiftChangeInventoryOverview: TransactionOverview.formOverview,
    inventoryRecordOverview: TransactionOverview.formOverview,
    inventoryOverview: TransactionOverview.formOverview,
    isDoubleSignature: false,
    acceptSaldoMismatchCheckbox: false,
    connectedTransactionRecordId: null,
    connectedTransactionRecordIds: null,
    setCrosscheckOverview: (value: number) =>
        set(() => ({ crosscheckOverview: value })),
    setWithdralOverview: (value: number) =>
        set(() => ({ withdrawalOverview: value })),
    setDepositOverview: (value: number) =>
        set(() => ({ depositOverview: value })),
    setDisposedOverview: (value: number) =>
        set(() => ({ depositOverview: value })),
    setAmbulanceOverview: (value: number) =>
        set(() => ({ ambulanceOverview: value })),
    setShiftChangeInventoryOverview: (value: number) =>
        set(() => ({ shiftChangeInventoryOverview: value })),
    setInventoryOverview: (value: number) =>
        set(() => ({ inventoryOverview: value })),
    setInventoryRecordOverview: (value: number) =>
        set(() => ({ inventoryRecordOverview: value })),
    setDoubleSignature: (value: boolean) =>
        set(() => ({ isDoubleSignature: value })),
    setAcceptSaldoMismatchCheckbox: (value: boolean) =>
        set(() => ({ acceptSaldoMismatchCheckbox: value })),
    setConnectedTransactionRecordId: (value: string) =>
        set(() => ({ connectedTransactionRecordId: value })),
    setConnectedTransactionRecordIds: (value: string[]) =>
        set(() => ({ connectedTransactionRecordIds: value })),
    resetOverviews: () =>
        set(() => ({
            crosscheckOverview: TransactionOverview.formOverview,
            withdrawalOverview: TransactionOverview.formOverview,
            depositOverview: TransactionOverview.formOverview,
            ambulanceOverview: TransactionOverview.formOverview,
            shiftChangeInventoryOverview: TransactionOverview.formOverview,
            inventoryOverview: TransactionOverview.formOverview,
            inventoryRecordOverview: TransactionOverview.formOverview,
            isDoubleSignature: false,
            acceptSaldoMismatchCheckbox: false,
            connectedTransactionRecordId: null,
            connectedTransactionRecordIds: null,
        })),
});

export { createFormOverviewSlice };
export type { FormOverviewSlice };
